module.exports = __webpack_public_path__ + "media/images/icon/view-00ba538f39c734ca03e9d9d6bde93a09.svg";